// src/types/openLeaks.types.ts

export interface DataLeak {
  id: number;
  Name: string;
  Title: string;
  BreachDate: string;
  PwnCount: number | null;
  Description: string;
  DataClasses: string[];
  BreachStatus: 'confirmed' | 'claimed_credible' | 'claimed_unreliable' | 'unspecified' | string;
  Country: string | null;
  Source: string | null;
  LogoPath: string | null;
  IsVerified: boolean;
  severity: string | 'critical' | 'high' | 'medium';
}

export interface LeakFilters {
  search?: string;
  status?: string;
  startDate?: string;
  endDate?: string;
  minAffected?: number;
  maxAffected?: number;
}

export interface LeakStats {
  totalLeaks: number;
  totalAffected: number;
  byStatus: Record<string, number>;
  byMonth: Record<string, number>;
  topCompanies: Array<{ company: string; count: number }>;
}

export interface FollowAlert {
  id: number;
  email: string;
  company: string;
  createdAt: string;
}

// Dictionnaire des statuts en français
export const statusLabels: Record<string, string> = {
  confirmed: 'Confirmée',
  claimed_credible: 'Revendiquée (crédible)',
  claimed_unreliable: 'Revendiquée (peu fiable)',
  unspecified: 'Non précisé'
};

// Couleurs des statuts
export const statusColors: Record<string, string> = {
  confirmed: '#10B981',      // Vert
  claimed_credible: '#F59E0B', // Orange
  claimed_unreliable: '#EF4444', // Rouge
  unspecified: '#9CA3AF'      // Gris
};

// Couleurs de sévérité
export const severityColors: Record<string, string> = {
  critical: '#EF4444',
  high: '#F97316',
  medium: '#F59E0B',
  low: '#10B981'
};